module.exports = __webpack_public_path__ + "img/animal.d5520c78.jpg";